<template>
  <div class="flex flex-col gap-2">
    <div
      v-if="loading"
    >
      <SkeletonMalomoTrackingWidget />
    </div>
    <template v-else-if="order">
      <MalomoTrackingDetails
        v-for="shipment in shipments"
        :key="shipment.id"
        v-bind="{ shipment, order }"
      />
    </template>
    <div v-else-if="error" class="text-center py-8">
      <p class="max-w-md mx-auto">
        We are having trouble locating your order.
        Please try re-entering your order details. If you
        haven't received your shipping details yet, it's
        possible your order is still being fulfilled and you
        won't be able to track your order yet.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { appendScript } from '@/utils'
import MalomoTrackingDetails from '@/components/theme/render/malomo-tracking-details.vue'
import SkeletonMalomoTrackingWidget from '@/components/theme/render/skeleton-malomo-tracking-widget.vue'
import type { MalomoOrder, Shipment } from '@/types'

const order = ref<MalomoOrder>()
const shipments = ref<Shipment[]>([])
const loading = ref(true)
const error = ref(false)

onMounted(async () => {
  loading.value = true
  error.value = false

  await appendScript('https://js.gomalomo.com/v2/', { id: 'malomo' })
  const malomo = window.Malomo(import.meta.env.VITE_MALOMO_KEY)
  malomo.fetchOrder()
    .then((response) => {
      console.log('response', response)
      order.value = response.body
      shipments.value = response.body.shipments
      console.log('order.value', order.value)

      loading.value = false
    })
    .catch(() => {
      loading.value = false
      error.value = true
    })
})

</script>
